import { useState } from 'react'
import { ApiError, downloadFile } from '../lib/api'
import { Button } from './ui'

/* One button for every generated file in the app.
 *
 * Replaces the `<a href target="_blank">` pattern, which breaks in the
 * installed app: the system browser it opens has no session, so the export
 * comes back 401. This fetches with the app's own credentials and saves the
 * result, and it can report a failure instead of silently opening a page of
 * JSON. */
export default function DownloadButton({
  path, filename, children, size = 'sm', variant = 'secondary',
}: {
  path: string
  filename: string
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  variant?: 'primary' | 'secondary' | 'ghost'
}) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function go() {
    setBusy(true)
    setError(null)
    try {
      await downloadFile(path, filename)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not download that file.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <Button variant={variant} size={size} loading={busy} onClick={go}>
        {children}
      </Button>
      {error && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--danger)' }}>{error}</span>
      )}
    </span>
  )
}
